import { toISODate } from "../../utils/date";

/**
 * Valores iniciais do formulário de Template de Treino.
 * Campo canônico: sessions[]. Sem "workouts" nem "blocks" na raiz.
 */
export const initialTemplateValues = {
    title: "",
    description: "",
    workoutType: "strength",
    objective: "",
    level: "",
    tags: [],
    isSingleDay: false,
    weeklyFrequency: 3,
    totalWeeks: 4,
    sessions: [],
};

/**
 * Valores iniciais do formulário de Prescrição Direta.
 */
export const initialPrescriptionValues = (date) => ({
    title: "Treino Direto",
    isSingleDay: false,
    weeklyFrequency: 3,
    startDate: date || toISODate(new Date()),
    endDate: "",
    sessions: [],
});
